import { Injectable } from '@angular/core';
import {  Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfig } from '../app.config';
import { IUserIdentification } from '../models/administration/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';  
import * as jwt_decode from 'jwt-decode';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json;', 'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
    Accept: 'q=0.8;application/json;q=0.9'
  })
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  headers: Headers;

  private apiURL = this.config.apiUrl;

  constructor(
    private http: HttpClient,
    private config: AppConfig,
    private router: Router,



    ) { 

  
    }

  Login(credentials: any): Observable<any> {
    console.log(credentials);
    const body = JSON.stringify(credentials);
    return this.http.post(this.apiURL + 'Security/users/login', body, httpOptions)
      .pipe(map(this.extractData),
        catchError(this.handleErrors));
  }

  setLoginUser(userData: any) {
    localStorage.setItem(this.config.Session_User, JSON.stringify(userData));
  }


  setToken(token: string) {
    localStorage.setItem(this.config.JWT_Token, token);
  }



  getToken() {
    return localStorage.getItem(this.config.JWT_Token);
  }

  isLoggedIn() {
    return this.getToken() !== null;
  }




  getCurrentUser() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem(this.config.Session_User));
      if (currentUser != null) {
        return currentUser;
      } else {
        return 'Guest';
      }
    }
  }

  getLoginUserDisplayName() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem(this.config.Session_User));

      if (currentUser != null) {
        return currentUser.SurName + ' ' + currentUser.PostNames;
      } else {
        return 'Guest';
      }
    }
  }

  getLoginUserDisplayId() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem(this.config.Session_User));

      if (currentUser != null) {
        return currentUser.Id;
      } else {
        return 'Guest';
      }
    }
  }



  getLoginUserDisplayRole() {
    if (this.isLoggedIn()) {
      const currentUser = JSON.parse(localStorage.getItem(this.config.Session_User));

      if (currentUser != null) {
        return currentUser.Role;
      } else {
        return 'Guest';
      }
    }
  }


  Logout(): Observable<any> {
    return this.destroyAuthentication();
  }


  destroyAuthentication(): Observable<any> {

    localStorage.clear();

    const currentUser = JSON.parse(localStorage.getItem(this.config.Session_User));
    // const currentUser = jwt_decode('');
    const body = JSON.stringify('');
    return this.http
      .post(this.apiURL + 'security/users/logout/' + currentUser.Id, body, httpOptions)
      .pipe(map((response: Response) =>
      console.log(response.json()),
      ),
        catchError(this.handleErrors));

  }


  private extractData(res: Response) {
    const body = JSON.parse(JSON.stringify(res || null));
    return body || {};
  }

  loginForm() {
    this.router.navigateByUrl('auth/login'/* , { skipLocationChange: true }*/);

  }

  private handleErrors(error: Response): Observable<any> {
    if (error.status > 0) {
      if (error.status > 0) {
        if (error.status === 401) {
          return throwError('Unauthorized');
        } else if (error.status === 500) {
          return throwError('Contact your administrator');
        } else if (error.status === 302) {
          return throwError('Already have an open session.');
        } else if (error.status === 404) {
          return throwError('Not Found');
        } else {
          return throwError(error['_body'] || 'Server error');
        }
      }
    } else {
      return throwError('Please check your connection or Contact Your administrator');
    }
  }


  private handleApiError(error: any) {
    const message = JSON.parse(error._body).message;
    const errMsg = (message) ? message : error.status ?
      `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg);
    return Observable.throw(errMsg);
  }


  // Users controller 
  getAllUsers(user): Observable<any> {
    return this.http.post<any>(this.apiURL + 'Security/Users/', JSON.stringify(user), httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
  // // Users controller 
  // getAllUsers(): Observable<IUserIdentification[]> {
  //   return this.http.get<IUserIdentification[]>(this.apiURL + 'Security/Users/')
  //   .pipe(
  //     catchError(this.errorHandler)
  //   )
  // }
   
  createUser(user): Observable<IUserIdentification> {
    return this.http.post<IUserIdentification>(this.apiURL + 'Security/Users/', JSON.stringify(user), httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }  
   
  forgotPassword(email): Observable<any> {
    return this.http.put<any>(this.apiURL + 'Security/ForgetPassword/'+ email,  httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }  
   
  findUser(id): Observable<IUserIdentification> {
    return this.http.get<IUserIdentification>(this.apiURL + 'Security/Users/' + id)
    .pipe(
      catchError(this.errorHandler)
    )
  }

  findUserByRole(roleId): Observable<IUserIdentification> {
    return this.http.get<IUserIdentification>(this.apiURL + 'Security/Users/' + roleId)
    .pipe(
      catchError(this.errorHandler)
    )
  }
   
  updateUser(id, user): Observable<IUserIdentification> {
    return this.http.put<IUserIdentification>(this.apiURL + 'Security/Users/' + id, JSON.stringify(user), httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
   
  deleteUser(id){
    return this.http.delete<IUserIdentification>(this.apiURL + 'Security/Users/' + id, httpOptions)
    .pipe(
      catchError(this.errorHandler)
    )
  }
    
  
  errorHandler(error) {
    let errorMessage = '';
    if(error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
 }

}
